import { Button, Typography } from "@mui/material";
import { FaChevronRight } from "react-icons/fa6";
import { Link } from "react-router-dom";

import { usePreviewCourse } from "../../hooks/usePreviewCourse";

export function CourseCheckoutButton() {
	const { course, owned } = usePreviewCourse();

	if (!course) {
		return null;
	}

	return (
		<div className="checkout-button-container">
			<Link to={`/services/${course.courseSlug}/checkout`}>
				<Button className="normal-button primary-button checkout-button">
					<Typography className="normal-text">Check Availability</Typography>
				</Button>
			</Link>
			<div style={{ flex: 1 }} />
			{owned && (
				<Link
					className="learn-now-button"
					to={`/learning/${course.courseSlug}`}>
					<Typography className="big-text bold">Learn Now</Typography>
					<FaChevronRight className="normal-icon" />
				</Link>
			)}
		</div>
	);
}
